const resources = {
    getStarted: 'Démarrer',
    signInToGetStarted: 'Ouvrir une session pour commencer'
};

module.exports = function getResource(label) {
    return resources[label];
};
